var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return Promise.all([

	]).then(next);
};